export default __webpack_public_path__ + "static/media/ready-set-type-alternate.b7107793.png";